import React, { useState } from "react";

const UpdateContactModal = ({ user, onClose }) => {
    const [email, setEmail] = useState(user.email);
    const [phone, setPhone] = useState(user.phone || "");
    const [address, setAddress] = useState(user.address || "");

    const formatPhoneNumber = (value) => {
        const digits = value.replace(/\D/g, "").slice(0, 10); // Allow only digits, max 10
        const formatted = digits.replace(/(\d{3})(\d{3})(\d{1,4})/, (_, p1, p2, p3) => {
            return `${p1}-${p2}-${p3}`.trim();
        });
        return formatted;
    };

    const handlePhoneChange = (e) => {
        const formattedPhone = formatPhoneNumber(e.target.value);
        setPhone(formattedPhone);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle the update logic here (e.g., dispatch an action to update the user info)
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-semibold mb-4">Update Contact Information</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">Email</label>
                        <input 
                            type="email" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)} 
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">Phone</label>
                        <input 
                            type="text" 
                            value={phone} 
                            onChange={handlePhoneChange} 
                            className="w-full border rounded px-3 py-2"
                            placeholder="###-###-####"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">Address</label>
                        <textarea 
                            value={address} 
                            onChange={(e) => setAddress(e.target.value)} 
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>
                    <div className="flex justify-end space-x-2">
                        <button 
                            type="button" 
                            onClick={onClose} 
                            className="px-4 py-2 bg-gray-300 rounded-lg"
                        >
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            className="px-4 py-2 bg-charcoal text-white rounded-lg"
                        >
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdateContactModal;
